// Custom theme scripts (loaded from layout/theme.liquid).
// Kept inside this IIFE so variables don't leak into the global scope.
(function () {
  document.addEventListener('theme:pagination:done', function (e) {
    const { sectionId } = e.detail;

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const target = document.querySelector('.collection__heading') || section;
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 0;

    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - headerHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    const swatchItems = document.querySelectorAll('.product__color-swatch-item');
    const titleElement = document.querySelector('[data-color-swatch-title]');
    if (swatchItems) {
      const defaultTitle = titleElement ? titleElement.textContent : null;
      const defaultItem = document.querySelector('.product__color-swatch-item.active');
      swatchItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));

          this.classList.add('active');

          const newDescription = this.getAttribute('data-short-description');
          if (newDescription && titleElement) {
            titleElement.textContent = newDescription;
          }
        });
        item.addEventListener('mouseleave', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));
          if (titleElement) {
            titleElement.textContent = defaultTitle;
          }
          if (defaultItem) {
            defaultItem.classList.add('active');
          }
        });
      });
    }

    // Custom scroll behavior
    const elem = document.querySelector('.product__inner');
    if (elem) {
      const pt = window.getComputedStyle(elem, null).getPropertyValue('padding-top');
      elem.style.top = `calc(-${pt} + var(--header-height, 47px))`;
    }

    // Vertical dropdown menu 3 level images changing
    const selectors = {
      verticalDropdown: '.header__dropdown.header__dropdown--vertical',
      imagesContainer: '.header__dropdown__right',
      linkItem: '.navlink.navlink--grandchild',
      defaultImage: '[data-connected-link="default"]',
    };

    const verticalDropdowns = document.querySelectorAll(selectors.verticalDropdown);

    const updateVerticalDropdownImage = (container, imageElem) => {

      if (!imageElem || imageElem.classList.contains('block')) return;

      const currentImage = container.querySelector('.block');

      currentImage.classList.add('hidden');
      currentImage.classList.remove('block');

      imageElem.classList.add('block');
      imageElem.classList.remove('hidden');
    };

    verticalDropdowns.forEach((dropdown) => {
      const imagesContainer = dropdown.querySelector(selectors.imagesContainer);

      if (imagesContainer) {
        const defaultImage = imagesContainer.querySelector(selectors.defaultImage);
        dropdown.querySelectorAll(selectors.linkItem).forEach(link => {
          link.addEventListener('mouseenter', ({ target }) => {
            const connectedImage = imagesContainer.querySelector(`[data-connected-link="${target.getAttribute(
                    'href')}"]`);
            if (connectedImage) {
              updateVerticalDropdownImage(imagesContainer, connectedImage);
              return;
            }

            updateVerticalDropdownImage(imagesContainer, defaultImage);
          });
        });
      }
    });
  });

  const collectionDescription = document.querySelector('.collection__heading__description');
  if (!collectionDescription) return;

  const collectionDescriptionText = collectionDescription.querySelector('p');
  if (!collectionDescriptionText) return;

  const desktopLimit = collectionDescription.getAttribute('data-max-chars-desktop') || 200;
  const mobileLimit = collectionDescription.getAttribute('data-max-chars-mobile') || 200;

  const fullText = collectionDescriptionText.innerText.trim();
  const isMobile = window.innerWidth < 768;
  const limit = isMobile ? mobileLimit : desktopLimit;

  if (fullText.length <= limit) {
    collectionDescriptionText.innerText = fullText;
    return;
  }

  const shortText = fullText.slice(0, limit);
  collectionDescriptionText.innerHTML = `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

  const button = collectionDescriptionText.querySelector('.read-more-btn');
  let isExpanded = false;

  button.addEventListener('click', function () {
    isExpanded = !isExpanded;
    collectionDescriptionText.innerHTML = isExpanded
      ? `${fullText} <button class="read-more-btn active">${window.theme.strings.readLess}</button>`
      : `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

    collectionDescriptionText.querySelector('.read-more-btn').addEventListener('click', arguments.callee);
  });
})();